module.exports = __webpack_public_path__ + "media/images/athletes/4260-d4983b1dbd123afb7269a97a27c15edc.png";